import { createSelector } from 'reselect';

import { getReportsDomainColumns } from '../declarations/reportsDomain/reportsDomain';
import { ColumnsSettingsViewDict } from '../typings/common';
import { State } from '../typings/state';

export const selectReportsDomainColumns = createSelector(
    (state: State) => state.reportDomain.columnsSettings,
    (columnsSettings: ColumnsSettingsViewDict) => {
        return getReportsDomainColumns(columnsSettings);
    }
);
